import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As an npm user or organization member, you can create and publish public packages that anyone can download and use in their own projects.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Unscoped`}</strong>{` public packages exist in the global public registry namespace and can be referenced in a `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file with the package name alone: `}<inlineCode parentName="li">{`package-name`}</inlineCode>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Scoped`}</strong>{` public packages belong to a user or organization and must be preceded by the user or organization name when included as a dependency in a `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`@username/package-name`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`@org-name/package-name`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <h2>{`Next steps`}</h2>
    <ul>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "creating-and-publishing-scoped-public-packages"
        }}>{`Creating and publishing scoped public packages`}</a>{`"`}</li>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "creating-and-publishing-unscoped-public-packages"
        }}>{`Creating and publishing unscoped public packages`}</a>{`"`}</li>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "using-npm-packages-in-your-projects"
        }}>{`Using npm packages in your projects`}</a>{`"`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      